import React from "react";
import "../styles/Clientsmarquee.css";

// ─── Replace these with your actual client logo image paths ───────────────────
const CLIENT_IMAGES = Array.from({ length: 38 }, (_, i) => ({
  id: i + 1,
  src: `/assets/clients/client-${i + 1}.png`,   // ← swap with your real paths
  alt: `Client ${i + 1}`,
}));

// Split 38 images: first 19 → row 1 (right→left), next 19 → row 2 (left→right)
const ROW_1 = CLIENT_IMAGES.slice(0, 19);
const ROW_2 = CLIENT_IMAGES.slice(19, 38);

const MarqueeRow = ({ images, direction = "left", speed = 40 }) => {
  // Duplicate the list so the strip loops seamlessly
  const track = [...images, ...images];

  return (
    <div className="marquee-row-wrapper" aria-hidden="true">
      <div
        className={`marquee-track marquee-track--${direction}`}
        style={{ "--marquee-speed": `${speed}s` }}
      >
        {track.map((img, idx) => (
          <div className="marquee-card" key={`${img.id}-${idx}`}>
            <img src={img.src} alt={img.alt} draggable="false" />
          </div>
        ))}
      </div>
    </div>
  );
};

const ClientsMarquee = () => {
  return (
    <section className="clients-section">
      <div className="clients-header">
        <span className="clients-eyebrow">Trusted By</span>
        <h2 className="clients-heading">Our Clients</h2>
        <p className="clients-subtext">
          Partnering with businesses that demand excellence.
        </p>
      </div>

      <div className="marquee-stage">
        {/* Row 1 — scrolls Right → Left */}
        <MarqueeRow images={ROW_1} direction="left" speed={38} />

        {/* Row 2 — scrolls Left → Right */}
        <MarqueeRow images={ROW_2} direction="right" speed={42} />
      </div>
    </section>
  );
};

export default ClientsMarquee;